import { useState, useEffect, useCallback } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useDispatch } from 'react-redux'
import useTruckPlates from 'tennders-market/truck/hooks/useTruckPlates'
import { apiPut } from 'tennders-stracture/libs/api'
import { GButton, GInput } from 'tennders-common/form/components'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import GModal from 'tennders-market/common/components/element/GModal'
import { useToast } from 'tennders-common/hooks/useToast'
import { dispatchUpdatePlateNumbers } from 'tennders-common/stores/prompt/action'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

const PlateNumbers = ({ ...rest }) => {
  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()
  const dispatch = useDispatch()
  const { transaction, updatePlateNumbers } = useTruckPlates()
  const { fetchTransactions } = useTransactions()
  const [form, setform] = useState({
    plateNumber: transaction?.matchedTruck?.plateNumber,
    trailerNumber: transaction?.matchedTruck?.trailerNumber
  })
  const [copiedPlates, setCopiedPlates] = useState([])
  const [errors, seterrors] = useState({})
  const [submitting, setsubmitting] = useState(false)
  const { refreshTransaction } = useTransactions()
  const savePlates = async () => {
    setsubmitting(true)
    const response = await apiPut(`trucks/${transaction?.matchedTruck?.id}`, form)
    if (response.error) {
      toastError(response.error)
    } else if (response.errors) {
      seterrors(response.errors)
    } else {
      toastSuccess(t('modals:platesUpdated'))
      updatePlateNumbers(false)
      fetchTransactions()
      if (transaction) {
        refreshTransaction(transaction?.id)
      }
    }
    setsubmitting(false)
  }

  const commonProps = {
    onChange: (k, v) => setform({ ...form, [k]: v }),
    form,
    errors
  }

  const pasteFromClipboard = useCallback(() => {
    setform({
      ...form,
      plateNumber: copiedPlates[0],
      trailerNumber: copiedPlates[1]
    })
    setCopiedPlates([])
  }, [form, copiedPlates])

  useEffect(() => {
    // Function to check if there's data in the clipboard
    const checkClipboard = async () => {
      try {
        const clipboardContent = await navigator.clipboard.readText()
        const plates = clipboardContent.split(' / ')
        if (plates?.length === 2) {
          setCopiedPlates(plates)
        }
      } catch (err) {
      // handle catch
      }
    }
    if (transaction) {
      checkClipboard()
    }
  }, [transaction])

  useEffect(() => {
    if (transaction) {
      setform({
        ...form,
        plateNumber: transaction?.matchedTruck?.truckPlate || '',
        trailerNumber: transaction?.matchedTruck?.trailerPlate || ''
      })
    }
  }, [transaction])

  return (
    <GModal
      isOpen={!!transaction}
      close={() => dispatch(dispatchUpdatePlateNumbers(false))}
      size={400}
      {...rest}
    >
      <div className="tennders-modal-body w-100">
        <div className="d-flex">
          <div className="p-20">
            <h3 className="bold">{t('modals:plateNumbers')}</h3>
            <GInput
              label={t('modals:truckPlateNumber')}
              name="plateNumber"
              maxLength={INPUT_CHARACTER_LIMITS.PLATES}
              {...commonProps}
              placeholder={t('modals:truckPlateNumber')}
            />
            <br />
            <GInput
              label={t('modals:trailerPlateNumber')}
              name="trailerNumber"
              {...commonProps}
              maxLength={INPUT_CHARACTER_LIMITS.PLATES}
              placeholder={t('modals:trailerPlateNumber')}
            />
            {copiedPlates?.length > 0 && (
              <GButton
                onClick={pasteFromClipboard}
                className="btn-border standard-btn cursor-pointer mr-10 mt-20"
              >
                Paste from Clipboard
              </GButton>
            )}
            <GButton
              disabled={!form.trailerNumber && !form.plateNumber}
              onClick={savePlates}
              submitting={submitting}
              className="btn standard-btn cursor-pointer mt-20"
            >
              {t('modals:save')}
            </GButton>
          </div>
        </div>
      </div>
    </GModal>
  )
}

export default PlateNumbers
